import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { ApplicationProviders } from './app/application-providers.js';
import { createAppBrowserRouter } from './app/app-shell.js';
import { createApplicationQueryClient } from './app/query-client.js';
import './styles.css';

const rootElement = document.querySelector('#root');
if (rootElement === null) {
  throw new Error('Application root element is missing');
}

const queryClient = createApplicationQueryClient();
const router = createAppBrowserRouter();

createRoot(rootElement).render(
  <StrictMode>
    <ApplicationProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </ApplicationProviders>
  </StrictMode>,
);
